import { render, staticRenderFns } from "./shippingExpenseEntry.vue?vue&type=template&id=b39367d2&scoped=true&"
import script from "./shippingExpenseEntry.vue?vue&type=script&lang=js&"
export * from "./shippingExpenseEntry.vue?vue&type=script&lang=js&"
import style0 from "./shippingExpenseEntry.vue?vue&type=style&index=0&id=b39367d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39367d2",
  null
  
)

export default component.exports